import { NaturalNumber_Schema } from "@/utilities";
import { z } from "zod";

export const UserBankInfoId_Schema = NaturalNumber_Schema;

export const UserBankInfo_Schema = z.object({
  id: UserBankInfoId_Schema,
  accountNumber: z.string(), // "002-001223/0700"
  iban: z.string(), // "CZ80100000000000000000000000"

  // There is more properties however we do not use them.
  // Feel free to define them if needed.
});
